import React, { useState } from "react";
import PostCard from "../components/PostCard";
import { FaStar, FaHeart, FaShoppingCart, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Home() {
  const [posts, setPosts] = useState([
    {
      id: 1,
      title: "Μυστικά της Τέλειας Κρέμας Patisserie",
      excerpt:
        "Ανακαλύψτε τα επαγγελματικά μυστικά για τη δημιουργία της πιο λεπτής και γευστικής κρέμας που θα μεταμορφώσει τα γλυκά σας σε αριστουργήματα ζαχαροπλαστικής.",
      date: "15 Ιανουαρίου 2025",
      image: "/images/1.jpg",
      isFavorite: false,
    },
    {
      id: 2,
      title: "Τέχνη Διακόσμησης με Fondant",
      excerpt:
        "Μάθετε τις τεχνικές των επαγγελματιών για να δημιουργήσετε εντυπωσιακά γλυκά με fondant που θα καθηλώσουν τους καλεσμένους σας με την ομορφιά και τη γεύση τους.",
      date: "12 Ιανουαρίου 2025",
      image: "/images/2.jpg",
      isFavorite: false,
    },
    {
      id: 3,
      title: "Γαλλικά Macaron: Οδηγός για Αρχάριους",
      excerpt:
        "Κατακτήστε την τέχνη των γαλλικών macaron με αυτόν τον λεπτομερή οδηγό που περιλαμβάνει όλα τα μυστικά για την τέλεια υφή και την απαλή γεύση.",
      date: "10 Ιανουαρίου 2025",
      image: "/images/3.jpg",
      isFavorite: false,
    },
    {
      id: 4,
      title: "Σοκολατένιες Δημιουργίες που Εντυπωσιάζουν",
      excerpt:
        "Εξερευνήστε τον μαγικό κόσμο της σοκολάτας και μάθετε πώς να δημιουργείτε εκπληκτικά επιδόρπια που συνδυάζουν την πλούσια γεύση με την καλλιτεχνική παρουσίαση.",
      date: "8 Ιανουαρίου 2025",
      image: "/images/4.jpg",
      isFavorite: false,
    },
    {
      id: 5,
      title: "Ζύμες Σφολιάτας: Από το Βασικό στο Προχωρημένο",
      excerpt:
        "Αποκτήστε όλες τις γνώσεις για τη δημιουργία τέλειας ζύμης σφολιάτας, από τις βασικές τεχνικές μέχρι τις πιο σύνθετες παραλλαγές που θα ξεχωρίσουν τις δημιουργίες σας.",
      date: "5 Ιανουαρίου 2025",
      image: "/images/5.jpg",
      isFavorite: false,
    },
  ]);

  const [showFavoriteModal, setShowFavoriteModal] = useState(false);

  const handleFavoriteToggle = (postId) => {
    setPosts(
      posts.map((post) =>
        post.id === postId ? { ...post, isFavorite: !post.isFavorite } : post,
      ),
    );
    setShowFavoriteModal(true);
    setTimeout(() => setShowFavoriteModal(false), 2000);
  };

  return (
    <>
      <Helmet>
        <title>
          Neralen - Ζαχαροπλαστική Τέχνη | Συνταγές & Τεχνικές Patisserie
        </title>
        <meta
          name="description"
          content="Neralen - Ανακαλύψτε τον κόσμο της ζαχαροπλαστικής τέχνης με αυθεντικές συνταγές, επαγγελματικές συμβουλές και τεχνικές patisserie για κάθε επίπεδο"
        />
      </Helmet>

      <div>
        <section className="hero-section">
          <h2>Καλώς Ήρθατε στον Κόσμο της Ζαχαροπλαστικής Τέχνης</h2>
          <p>
            Ανακαλύψτε τα μυστικά των επαγγελματιών pastry chefs και
            μεταμορφώστε τις δημιουργίες σας σε αληθινά αριστουργήματα γεύσης
            και αισθητικής, με έμπνευση για τούρτεσ γενεθλιων
          </p>

          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <FaStar />
              </div>
              <h3>Επαγγελματικές Συνταγές</h3>
              <p>
                Δοκιμασμένες συνταγές από έμπειρους ζαχαροπλάστες, με
                λεπτομερείς οδηγίες βήμα προς βήμα
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaHeart />
              </div>
              <h3>Δημιουργίες με Αγάπη</h3>
              <p>
                Κάθε συνταγή δημιουργείται με πάθος και αφοσίωση για το τέλειο
                αποτέλεσμα
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaShoppingCart />
              </div>
              <h3>Πρακτικές Συμβουλές</h3>
              <p>
                Χρήσιμες τεχνικές και μυστικά που θα βελτιώσουν τις ικανότητές
                σας στη ζαχαροπλαστική
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <FaHome />
              </div>
              <h3>Για Κάθε Επίπεδο</h3>
              <p>
                Από αρχάριους μέχρι προχωρημένους, βρείτε συνταγές για κάθε
                επίπεδο δεξιοτήτων
              </p>
            </div>
          </div>

          <div className="stats-section">
            <div className="stat-item">
              <span className="stat-number">15000+</span>
              <span className="stat-label">Ευχαριστημένοι Αναγνώστες</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">8</span>
              <span className="stat-label">Χρόνια Εμπειρίας</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">500+</span>
              <span className="stat-label">Δημοσιευμένες Συνταγές</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">98%</span>
              <span className="stat-label">Ποσοστό Επιτυχίας</span>
            </div>
          </div>

          <a href="#posts" className="cta-button">
            Ανακαλύψτε τις Συνταγές
          </a>
        </section>

        <section className="about-blog-section">
          <h2>Η Ζαχαροπλαστική ως Τέχνη και Επιστήμη</h2>

          <p>
            Το Neralen είναι πολύ περισσότερο από ένα απλό blog ζαχαροπλαστικής.
            Είναι ένας ολοκληρωμένος οδηγός που συνδυάζει την παραδοσιακή τέχνη
            της ζαχαροπλαστικής με τις σύγχρονες τεχνικές και τις επιστημονικές
            γνώσεις που κρύβονται πίσω από κάθε επιτυχημένη δημιουργία. Η ομάδα
            μας αποτελείται από επαγγελματίες pastry chefs με πολυετή εμπειρία
            σε κορυφαία ζαχαροπλαστεία της Ευρώπης, που μοιράζονται γενναιόδωρα
            τις γνώσεις και τα μυστικά τους, όπως τις τεχνικές για τούρτεσ
            γενεθλίων για κορίτσια.
          </p>

          <p>
            Κάθε άρθρο που δημοσιεύουμε είναι προϊόν εκτενούς έρευνας και
            πολλαπλών δοκιμών. Δεν αρκούμαστε απλά στο να σας δώσουμε μια
            συνταγή, αλλά σας εξηγούμε το γιατί πίσω από κάθε βήμα, τη χημεία
            των υλικών, τις αντιδράσεις που λαμβάνουν χώρα κατά το ψήσιμο, και
            πώς να προσαρμόσετε τις τεχνικές σύμφωνα με τις δικές σας
            προτιμήσεις. Πιστεύουμε ότι η κατανόηση των βασικών αρχών σας κάνει
            καλύτερους ζαχαροπλάστες και σας επιτρέπει να πειραματίζεστε με
            αυτοπεποίθηση, δημιουργώντας τούρτεσ γενεθλίων.
          </p>

          <p>
            Από το 2017, το Neralen έχει βοηθήσει χιλιάδες ανθρώπους να
            ανακαλύψουν το πάθος τους για τη ζαχαροπλαστική, να βελτιώσουν τις
            δεξιότητές τους, και να δημιουργήσουν αξέχαστες στιγμές μέσα από τις
            γλυκές τους δημιουργίες. Είτε είστε αρχάριοι που θέλετε να μάθετε τα
            βασικά, είτε προχωρημένοι που αναζητάτε νέες προκλήσεις, το Neralen
            είναι ο ιδανικός σύντροφος στο γλυκό σας ταξίδι. Με πάνω από 500
            συνταγές, λεπτομερείς οδηγούς, video tutorials, και μια ζωντανή
            κοινότητα μελών, σας προσφέρουμε όλα τα εργαλεία που χρειάζεστε για
            να πετύχετε και να σχεδιάσετε μοναδικές τουρτεσ γενεθλια.
          </p>

          <p>
            Η φιλοσοφία μας βασίζεται σε τρεις πυλώνες: ποιότητα, προσβασιμότητα
            και καινοτομία. Κάθε συνταγή ελέγχεται πολλαπλές φορές για να
            εξασφαλίσουμε ότι είναι αξιόπιστη και εύκολα εφαρμόσιμη στο σπίτι
            σας. Χρησιμοποιούμε υλικά που μπορείτε να βρείτε εύκολα, και
            προσφέρουμε εναλλακτικές επιλογές όπου χρειάζεται. Παράλληλα, δεν
            σταματάμε να πειραματιζόμαστε με νέες τάσεις, εξωτικά υλικά, και
            σύγχρονες τεχνικές που θα εμπλουτίσουν το ρεπερτόριό σας.
          </p>
        </section>

        <section className="posts-section" id="posts">
          <h2>Τελευταίες Δημοσιεύσεις</h2>
          <div className="posts-grid">
            {posts.map((post) => (
              <PostCard
                key={post.id}
                post={post}
                onFavoriteToggle={handleFavoriteToggle}
              />
            ))}
          </div>
        </section>

        {showFavoriteModal && (
          <div className="modal">
            <div className="modal-content">
              <h2>Αγαπημένα</h2>
              <p>Το άρθρο προστέθηκε στα αγαπημένα σας!</p>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Home;
